import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vb-withdrawal-percentage-input-label',
  templateUrl: './vb-withdrawal-percentage-input-label.component.html',
  styleUrls: ['./vb-withdrawal-percentage-input-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbWithdrawalPercentageInputLabelComponent {
  @Input() indicatorColour: string = '';
  @Input() fundName: string = '';
  @Input() balance: string = '';
}
